// Utility helpers to derive dealer zip and chrome style id with robust fallbacks
// Legacy behavior relied on API.utils.getVehicleData() which supplied vehicle.address.postalCode (dealer zip)
// and chromeId. After removing API, we must pull these from other DDC globals if missing.

export const deriveDealerZip = (vehicle) => {
	// Primary: vehicle's address.postalCode
	const fromVehicle = vehicle?.address?.postalCode;
	// DDC dataLayer vehicle address
	const fromDataLayer = window?.DDC?.dataLayer?.vehicles?.[0]?.address?.postalCode;
	// DDC user/dealer location objects
	const fromDealerLocation = window?.DDC?.userLocation?.dealerPostalCode;
	const fromUserLocation = window?.DDC?.userLocation?.userPostalCode; // sometimes used as fallback
	// Cookie (historical usage in esntial helpers)
	const fromCookie = window?.Cookies?.get?.('DDC.postalCode');

	return fromVehicle || fromDataLayer || fromDealerLocation || fromUserLocation || fromCookie || null;
};

export const resolveDealerZip = (vehicle) =>
	vehicle?.address?.postalCode || vehicle?.address?.zip || deriveDealerZip(vehicle);

export const resolveShopperZip = (dealerZip) =>
	window?.DDC?.userLocation?.userPostalCode || dealerZip;

export const deriveChromeStyleId = (vehicle) => {
	// Primary: vehicle.chromeId (legacy field)
	const chromeId = vehicle?.chromeId || vehicle?.chromeStyleId;
	// Possible structure in dataLayer
	const dataLayerStyleId = window?.DDC?.dataLayer?.vehicles?.[0]?.style?.id || window?.DDC?.dataLayer?.vehicles?.[0]?.chromeId;
	const raw = chromeId || dataLayerStyleId;
	if (!raw) return null;
	const parsed = parseInt(raw, 10);
	return Number.isNaN(parsed) ? null : parsed;
};

